import { render, staticRenderFns } from "./Recensione.vue?vue&type=template&id=1f2f83ec&"
import script from "./Recensione.vue?vue&type=script&lang=js&"
export * from "./Recensione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports